import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import React from 'react';
export function IntegerField({ value, label, min, max, onChange, }) {
    function isValueValid(value) {
        return (value !== undefined &&
            Number.isInteger(value) &&
            (min === undefined || value >= min) &&
            (max === undefined || value <= max));
    }
    const [error, setError] = React.useState(!isValueValid(value));
    return (_jsx(TextField, { type: "number", value: value, label: label, onChange: (event) => {
            const newValue = parseInt(event.target.value, 10);
            const isValid = isValueValid(newValue);
            setError(!isValid);
            onChange(newValue);
        }, variant: "outlined", slotProps: {
            input: {
                inputProps: {
                    min,
                    max,
                },
            },
        }, error: error }));
}
//# sourceMappingURL=IntegerField.js.map